module.exports = __webpack_public_path__ + "img/Azrtxboard – 2.c2908166.png";